import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Switch from 'flarum/common/components/Switch';
import Stream from 'flarum/common/utils/Stream';
import Link from 'flarum/common/components/Link';
import Icon from 'flarum/common/components/Icon';
import { initiateNewDiscussion } from '../utils/discussionUtils';
export default class InactiveDiscussionAlert extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "checked", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.checked = Stream(false);
  }
  view() {
    const lastPostedAt = this.attrs.discussion.lastPostedAt();
    const time = lastPostedAt ? dayjs(lastPostedAt).fromNow() : null;
    return m("div", {
      className: "NecrobumpingAlert Alert Alert--warning"
    }, m("div", {
      className: "Alert-body"
    }, m("div", {
      className: "NecrobumpingAlert-content"
    }, m("div", {
      className: "NecrobumpingAlert-icon"
    }, m(Icon, {
      name: "fas fa-clock"
    })), m("div", {
      className: "NecrobumpingAlert-message"
    }, m("strong", {
      className: "NecrobumpingAlert-title"
    }, app.translator.trans('fof-prevent-necrobumping.forum.composer.inactive_discussion_alert.title', {
      time
    })), m("div", {
      className: "NecrobumpingAlert-details"
    }, m("p", null, app.translator.trans('fof-prevent-necrobumping.forum.composer.inactive_discussion_alert.description')), app.forum.attribute('fof-prevent-necrobumping.show_discussion_cta') && app.forum.attribute('canStartDiscussion') && m("p", null, app.translator.trans('fof-prevent-necrobumping.forum.composer.inactive_discussion_alert.cta'), ' ', m(Link, {
      onclick: e => {
        e.preventDefault();
        initiateNewDiscussion();
      }
    }, app.translator.trans('fof-prevent-necrobumping.forum.composer.inactive_discussion_alert.cta_button'))), m("div", {
      className: "NecrobumpingAlert-checkbox"
    }, m(Switch, {
      state: this.checked(),
      onchange: this.onchange.bind(this)
    }, app.translator.trans('fof-prevent-necrobumping.forum.composer.inactive_discussion_alert.confirmation'))))))));
  }
  onchange() {
    const newStatus = !this.checked();
    this.attrs.set(newStatus);
    this.checked(newStatus);
  }
}
flarum.reg.add('fof-prevent-necrobumping', 'forum/components/InactiveDiscussionAlert', InactiveDiscussionAlert);